// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	AllClientsSelectedCheckbox: 'all-clients-selected-checkbox',
	Checkbox: 'checkbox',
	NameBadge: 'name-badge',
	ViewButton: 'view-button',
	ReviewButton: 'review-button',
	ViewButton1: 'view-button-1',
	ReviewButton1: 'review-button-1',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
